import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import { useDispatch } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Modal, Button, ProgressIndicator, ReduxControls, noop } from 'rhombus-react';

import { splitFilename } from 'utils/common';

import { creativeFilenameMaxLength } from 'widgets/forms/validators/Creatives';
import { validFilenameCharacters } from 'widgets/forms/validators/validators';
import { asyncValidateSingleRename, baseFilenameRequired, uniqueFilename } from 'widgets/modals/creatives/bulk/upload/validators';

const RENAME_SINGLE_CREATIVE = "rename-single-creative";

function RenameSingleModal(props) {
	const {
		filename,

		onBack,
		onSingleRename,
		handleSubmit,

		initialize,
		change,

		valid,
		asyncValidating,
	} = props;

	const dispatch = useDispatch();
	const [base, extension] = splitFilename(filename);

	useEffect(() => {
		const initValue = `${base}_copy${extension}`;
		dispatch(initialize({ newName: initValue }));
		dispatch(change("alwaysDirty", true)); /*
			If you have a pristine form, redux-form doesn't bother to async validate on submit,
			so we always set this flag to false on initialize, and then always set it to true on
			reinitialize, to ensure that the form always has a dirty value, and always validates.
		*/
	}, []);

	function submitName(values) {
		onSingleRename(values.newName);
	}

	function renderContent(){
		return (
			<div className="c-modal-body">
				<ProgressIndicator isLoading={Boolean(asyncValidating)} />
				<div className="fields">
					<form id={RENAME_SINGLE_CREATIVE} onSubmit={handleSubmit(submitName)}>
						<Field
							name="newName"
							component={ReduxControls.Input}
							label="New File Name for Uploaded Creative"
							post={extension}
							normalize={value => `${value}${extension}`}
							format={value => value.substring(0, value.lastIndexOf("."))}
							validate={[uniqueFilename, baseFilenameRequired, creativeFilenameMaxLength, validFilenameCharacters]}
							required
							showPristineErrors
						/>
					</form>
				</div>
			</div>
		);
	}

	function renderFooter() {
		return (
			<>
				<Button onClick={() => onBack()} theme="default">Back</Button>
				<Button
					type="submit"
					form={RENAME_SINGLE_CREATIVE}
					theme="blue"
					disabled={Boolean(!valid || asyncValidating)}
				>
					Rename Creative
				</Button>
			</>
		);
	}

	let modalProps = {
		type: "modal",
		title: `Rename Uploaded Creative File - ${filename}`,
		allowFullScreen: false,
		className: "creative-upload-error-modal rename-single-modal",
		xClose: false,
		bladeProps: {
			verticallyCenter: true,
		},
		setAppTitle: false,
		renderContent,
		renderFooter,
	};

	return <Modal {...modalProps} />;
}

RenameSingleModal.displayName = "RenameSingleModal";

RenameSingleModal.propTypes = {
	libraryId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	filename: PropTypes.string,

	onBack: PropTypes.func,
	onSingleRename: PropTypes.func,

	isSubmitting: PropTypes.bool,
};

RenameSingleModal.defaultProps = {
	onBack: noop,
	onSingleRename: noop,

	isSubmitting: false,
};


export default reduxForm({
	form: RENAME_SINGLE_CREATIVE,
	initialValues: {
		newName: "",
	},
	asyncValidate: asyncValidateSingleRename,
	asyncBlurFields: [],
})(RenameSingleModal);
